import { render, staticRenderFns } from "./ScoresChart.vue?vue&type=template&id=912d8a36&"
import script from "./ScoresChart.vue?vue&type=script&lang=js&"
export * from "./ScoresChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports